import { mapActions } from "vuex";
import {
  getMonitorDirList,
  getMonitor,
  getMonitorPic,
  putSwitchRegion,
  getMeteoStationList
} from "@/api/http";
import RegionSelectDia from "@/components/Dialogs/RegionSelectDia";
import RegionChangeDia from "@/components/Dialogs/RegionChangeDia";
export const switchRegionMixin = {
  inject: ["reload"],
  components: {
    RegionChangeDia
  },
  methods: {
    handleCommand(command) {
      let strategy = {
        1: () => {
          this.changeRegionDlg();
        }
      };
      strategy[command]();
    },
    changeRegionDlg() {
      //打开对话框
      this.defaultProp = { label: "name", children: "children", value: "code" };
      this.$refs.rcd.show();
    },
    async changeRegion(region, type) {
      await putSwitchRegion({ current_region: region.code });
      await this.setCurrentRegion();
      const res = await getMeteoStationList();
      this.meteoStationList = res.data;
      if (!type && res.data[0]) {
        //手动切换区域时站点信息的本地存储
        this.getSetAddressSession("set", res.data[0]);
      }

      // this.reload();
    },
    getSetAddressSession(type, data) {
      //地址信息的session存储与提取
      switch (type) {
        case "set":
          data && sessionStorage.setItem("station", JSON.stringify(data));
          break;
        case "get":
          return sessionStorage.getItem("station")
            ? JSON.parse(sessionStorage.getItem("station"))
            : "";
      }
    },
    ...mapActions(["setCurrentRegion"])
  }
};
export const newsDetailMixin = {
  methods: {
    checkNews(news, data) {
      if (data) sessionStorage.setItem("news_list", JSON.stringify(data)); //本地存储
      const { href } = this.$router.resolve({
        name: "policyNewsDetail",
        query: { id: this.$route.query.id, new_id: news.id }
      });
      window.open(href, "_blank");
    }
  }
};
export const paginationMixin = {
  data() {
    return {
      pageOptions: {
        total: 0,
        currentPage: 1,
        pageSize: [20, 50, 100, 200],
        activeSize: 20,
        layout: `sizes,prev, pager, next, jumper`
      },
      metaList: [],
      metaData: []
    };
  },
  computed: {
    tableData() {
      return this.metaList[this.pageOptions.currentPage - 1] || [];
    }
  },
  methods: {
    currentChange(currentPage) {
      this.pageOptions.currentPage = currentPage;
    },
    handleSizeChange(size) {
      this.pageOptions.activeSize = size;
      this.metaList = this.initMeta(this.metaData, size);
    },
    initMeta(data, size) {
      let arr = [];
      data.forEach((item, index) => {
        let x = Math.floor(index / size);
        if (arr[x]) {
          arr[x].push(item);
        } else {
          arr[x] = [];
          arr[x].push(item);
        }
      });
      this.pageOptions.currentPage = 1;
      return arr;
    },
    indexMethod(index) {
      return (
        index +
        this.pageOptions.activeSize * (this.pageOptions.currentPage - 1) +
        1
      );
    }
  }
};
export const monitorMixin = {
  components: {
    RegionSelectDia
  },
  data() {
    return {
      mode: 1,
      dateList: [],
      defaultProp: {},
      date: {},
      station: "",
      stationList: [],
      stationsList: [],
      imgList: [],
      selectList: [],
      title: "请选择日期"
    };
  },
  methods: {
    initMonitor() {
      getMonitorDirList().then(res => {
        this.dateList = res.data;
        this.date = res.data[0];
      });
    },
    switchRegionDlg(type) {
      this.mode = type;
      this.type = 0;
      if (type == 1) {
        this.title = "请选择日期";
        this.defaultProp = { label: "label", value: "dir_str" };
        this.selectList = this.dateList;
      } else {
        this.title = "请选择站点";
        this.defaultProp = { label: "station_name", value: "station_id_c" };
        this.selectList = this.stationsList;
      }
      this.$refs.rsd.show();
    },
    switchRegion(data) {
      let index = this.selectList.findIndex(
        item => item[this.defaultProp.value] == data
      );
      this.date = this.dateList[index];
    },
    getMonitor(data) {
      getMonitor(data).then(res => {
        this.stationList = res.data;
      });
    },
    getMonitorPic(region_str, station) {
      getMonitorPic(region_str, station).then(res => {
        this.imgList = res.data;
      });
    },
    ...mapActions(["setCurrentRegion"])
  },
  watch: {
    station(val) {
      if (val) {
        this.getMonitorPic(this.date.dir_str, val);
      }
    },
    date(val) {
      this.station = "";
      this.imgList = [];
      this.getMonitor(this.date.dir_str);
    },
    stationList(val) {
      if (val[0] && val[0].label) {
        this.station = val[0].label;
        this.getMonitorPic(this.date.dir_str, val[0].label);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/js/mixins.js